class ProductPackDisplay extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('product-card') || this.closest('.product-details');
    this.scope?.addEventListener('variant:update', this.handleVariantUpdate);
  }

  disconnectedCallback() {
    this.scope?.removeEventListener('variant:update', this.handleVariantUpdate);
  }

  handleVariantUpdate = (event) => {
    const source = event.detail?.data?.html;
    if (!(source instanceof Document)) return;

    const productId = String(this.dataset.productId || '');
    const context = String(this.dataset.context || 'default');
    const candidates = source.querySelectorAll(
      `product-pack-display[data-context="${CSS.escape(context)}"]`
    );
    const replacement = Array.from(candidates).find(
      (candidate) => candidate.dataset.productId === productId
    );
    if (!(replacement instanceof HTMLElement)) return;

    const nextValue = replacement.querySelector('[data-pack-display-value]')?.textContent?.trim();
    const currentValue = this.querySelector('[data-pack-display-value]');
    if (!nextValue || !(currentValue instanceof HTMLElement)) return;

    currentValue.textContent = nextValue;
    this.dataset.packDisplaySource = replacement.dataset.packDisplaySource || 'selected-variant';
  };
}

if (!customElements.get('product-pack-display')) {
  customElements.define('product-pack-display', ProductPackDisplay);
}
